import { defineMessages } from "react-intl";

const baseId = "t.pages.DelegationManagementStepThree.";

export default defineMessages({
  mainTitle: {
    id: baseId + "mainTitle",
    defaultMessage: "Select Users",
  },
  searchUser: {
    id: baseId + "searchUser",
    defaultMessage: "Search Users",
  },
  delegaCTA: {
    id: baseId + "delegaCTA",
    defaultMessage: "Delegate selected user",
  },
  backCTA: {
    id: baseId + "backCTA",
    defaultMessage: "Back",
  },
  //FORM
  allFilterLabelForm: {
    id: baseId + "allFilterLabelForm",
    defaultMessage: "Name, surname, userID",
  },
  noUserFound: {
    id: baseId + "noUserFound",
    defaultMessage: "No users found",
  },
});
